import styled from "styled-components";

export const ImageVisualizerElem = styled.img`
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    border-radius: 20px;
    border: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
    cursor: pointer;
`;